exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-edit {\n  color: green;\n  cursor: pointer;\n  font-size: 18px;\n  float: right; }\n\n.heading-edit:hover {\n  color: black;\n  text-decoration: underline; }\n", ""]);

// exports
